import Axios2 from '@/utils/Axios2'

//获取设备开机记录列表
export function getEquipStartup(context) {
  let param = {}
  param.method = 'post'
  param.url = "/api/v1/risk/device/list";
  param.data = {
    branchId: context.savebranchId,
  }
  return Axios2.ajax(param).then((res) => {
    if (res.data && res.data.length > 0) {
      context.deviceList = res.data;
      context.isdevice = true;
    } else {
      context.isdevice = false;
    }
  }).catch(() => {
    context.isdevice = false;
  });
}

/**
 * 按类型统计隐患设备数量
 */
export function getDeviceType(context) {
  let param = {};
  param.method = "get";
  param.url = "/api/v1/risk/device/statisticByType";
  param.params = {
    branchId: context.savebranchId,
  }
  return Axios2.ajax(param).then((res) => {
    if (res.data) {
      context.deviceTypeList = [
        { power: res.data.typeCountMap["2"] },
        { heat: res.data.typeCountMap["1"] },
        { other: res.data.typeCountMap["0"] },
      ];
    }
  }).catch(() => {
    context.$message.error('获取设备类型统计失败');
  })
}

//获取隐患设备详情
export function getDeviceDetail(context, row) {
  let param = {};
  param.method = "get";
  param.url = "/api/v1/risk/device/record/list";
  param.params = {
    deviceId: row.id,
  }
  return Axios2.ajax(param).then((res) => {
    if (res.data) {
      context.deviceDetailList = res.data.dataList;
      context.showDeviceDetail = true;
    }
  }).catch(() => {
    context.$message.error('获取详情失败');
  });
}


//保存隐患设备备注
export function saveRemarkDevice(context, row) {
  if (!row.comment) {
    context.$message.warning('请输入备注内容');
    return Promise.reject('请输入备注内容');
  }

  let param = {};
  param.method = "get";
  param.url = "/api/v1/risk/device/comment/update";
  param.params = {
    deviceId: row.id,
    comment: row.comment,
  }

  return Axios2.ajax(param).then((res) => {
    if (res.code === 0) {
      context.$message.success('备注保存成功');
    } else {
      context.$message.error(res.msg || '保存失败');
      return Promise.reject(res.msg || '保存失败');
    }
  }).catch(() => {
    context.$message.error('保存失败');
    return Promise.reject('保存失败');
  });
}


//返回隐患设备列表
export function returnToList(context) {
  context.showDeviceDetail = false;
  context.deviceDetailList = [];
}
